function createManagementPaginationMethods({
  loadMethod,
  pageState = "currentPage",
}) {
  return {
    handleCurrentChange(value) {
      this[pageState] = value;
      this[loadMethod]();
    },
  };
}

module.exports = createManagementPaginationMethods;
